import { api } from 'common/app'


class authorization {
    isLogin = () =>{
        api.isLogin().then((res)=>{
            console.log(res)
            if (res.data == 0) {
                api.authurl({url:window.location.href}).then((res)=>{
                    if (res.code == 200) {
                        // console.log(res.data)
                        window.location.href=res.data
                    }
                },(err)=>{
                    console.log(err)
                });
            }
        },(err) => {
            console.log(err)
        })
    }

}
export default new authorization()



// WEBPACK FOOTER //
// ./src/common/utils/authorization.js